import {
  Button,
  ButtonVariantEnum,
} from "@booking/components/atoms/forms/Button";
import { SizeEnum } from "@booking/enums";
import { useScreenSize } from "@booking/hooks/useScreenSize";
import React from "react";

import { ColorEnum } from "@/enums";
import type { CommonProps } from "@/types";

import styles from "./StickyFooter.module.css";

const ref = "sticky-footer";

interface StickyFooterProps extends Partial<CommonProps> {
  actionText: string;
  isLoading: boolean;
  onClick: React.MouseEventHandler<HTMLAnchorElement | HTMLButtonElement>;
}

function useStickyFooter(props: StickyFooterProps) {
  const { actionText, isLoading, onClick } = props;

  return {
    actionText,
    isLoading,
    onClick,
  };
}

function StickyFooter(props: StickyFooterProps) {
  const { actionText, isLoading, onClick } = useStickyFooter(props);
  const { isMinLg } = useScreenSize();

  if (isMinLg) {
    return null;
  }

  return (
    <>
      <div className={styles[ref]}>
        <Button
          color={ColorEnum.DARKGREEN}
          size={SizeEnum.LARGE}
          onClick={onClick}
          variant={ButtonVariantEnum.SOLID}
        >
          {isLoading ? <span className="foo"></span> : actionText}
        </Button>
      </div>
    </>
  );
}

export default StickyFooter;
export { StickyFooter, type StickyFooterProps };
